/*
export const someAction = (state) => {}
 */
import { api } from 'src/plugins/axios'
import Vue from 'vue'
import { createQueryString } from 'src/utils'
import { notify } from 'src/plugins/notify'

export default {
  fetchAll,
}

async function fetchAll({ commit, state }, { pagination, filter, columns, exportOptions }) {
  commit('setLoading', true)
  try {
    const query = createQueryString({ pagination, filter, columns, })
    const { data } = await api.get('/events/fetchAll/' + query)
    if (data && !data.error && data.payload) {
      commit('setList', { events: data.payload.events })
      return data
    }

    notify.create({
      message: "Error loading event logs",
      type: "negative"
    })

    return null
  } catch (err) {
    console.log('error', err)
  } finally {
    commit('setLoading', false)
  }
}